import { render, staticRenderFns } from "./assetsTradeDetail.vue?vue&type=template&id=b230b402&scoped=true"
import script from "./assetsTradeDetail.vue?vue&type=script&lang=js"
export * from "./assetsTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./assetsTradeDetail.vue?vue&type=style&index=0&id=b230b402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b230b402",
  null
  
)

export default component.exports